export default __webpack_public_path__ + "static/media/96.9c502cf7.jpg";